/**
 * Moldura das telas de conta (login, cadastro, senha, verificação).
 *
 * Composição de tela, não componente novo de design system: só arruma
 * espaçamento em volta de Card/Field/Button, que continuam vindo do @mgdlead/ui.
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Card } from '@mgdlead/ui';

import { BrandMark } from '@mgdlead/ui';

export interface AuthLayoutProps {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  /** Link de escape no rodapé ("Já tem conta? Entrar"). */
  footer?: ReactNode;
}

export function AuthLayout({ title, description, children, footer }: AuthLayoutProps) {
  /*
    Composição do UI kit do export (tela de login): canvas cinza, marca centralizada acima,
    um painel branco de 400px com respiro largo, e o "ainda não tem conta?" fora do painel,
    em legenda. As outras telas de conta herdam a mesma moldura.
  */
  return (
    <div className="grid min-h-dvh place-items-center bg-background px-4 py-8 text-foreground md:p-6">
      <div className="flex w-full max-w-100 flex-col">
        <Link
          to="/"
          className="mx-auto mb-6 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="MGDLead — início"
        >
          <BrandMark />
        </Link>

        <Card className="flex flex-col gap-5 p-6 md:p-7">
          <header className="flex flex-col gap-1">
            <h1 className="text-lg font-semibold">{title}</h1>
            {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
          </header>

          {children}
        </Card>

        {footer ? <div className="mt-4 text-center text-xs text-subtle-foreground">{footer}</div> : null}
      </div>
    </div>
  );
}
